import React from 'react'
import Logo from '../logo'
import HRAuthLogo from '../../assets/svg/login-4.svg'
import OtherAuthLogo from '../../assets/svg/other_auth_image.svg'
import ForgotLogo from '../../assets/svg/forgot-password.svg'
import ForgotSpLogo from '../../assets/svg/forgot-password-ps.svg'
import pppLogo from '../../assets/img/ppp-white.png'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import Typewriter from '../fragments/typewriter-text'
import illustrateSVG from '../../assets/svg/illustrate-user.svg'

const AuthLayout = ({ children }) => {
  const { section } = useSelector((state) => state.sectionSlice)
  const location = useLocation()

  return (
    <main className='h-screen w-full bg-[#f8f8f8] py-10'>
      <div className={'flex w-full h-[90vh] items-center justify-center gap-3'}>
        <div className='md:flex hidden w-full'>
          <div className='w-[80%] ml-auto'>
            <img src={illustrateSVG} alt='centelHR' />
          </div>
        </div>
        <div className='flex flex-col items-center justify-center  h-full w-full overflow-y-auto min-h-fit'>
          <div className='flex flex-col md:w-[70%] py-4 px-7 w-[95%] mr-0 md:mr-auto min-h-fit bg-white shadow-sm border border-gray-500 rounded-[10px]'>
            <div className='mr-auto'>
              <Logo width={'160px'} height={'60px'} />
            </div>
            <div className='flex flex-col h-full'>{children}</div>
          </div>
        </div>
      </div>
      <div className='flex items-center gap-1 text-sm justify-center w-full'>
        <p> centelHr © 2025</p>
        <a
          href='https://centelhr.com/help-center'
          target='_blank'
          rel='noreferrrer'
          className='cursor-pointer opacity-60 hover:opacity-100 hover:underline transition-all ease-linear duration-100'
        >
          Help Center
        </a>
        <a
          href='https://centelhr.com/terms-of-use'
          target='_blank'
          rel='noreferrrer'
          className='cursor-pointer opacity-60 hover:opacity-100 hover:underline transition-all ease-linear duration-100'
        >
          Terms
        </a>
        <a
          href='https://centelhr.com/privacy-policy'
          target='_blank'
          rel='noreferrrer'
          className='cursor-pointer opacity-60 hover:opacity-100 hover:underline transition-all ease-linear duration-100'
        >
          Privacy
        </a>
      </div>
    </main>
  )
}

export default AuthLayout
